import {BaseController} from 'app/controllers/BaseController';
import type {CupStore, CupUserTokenPayload} from 'app/store/CupStore';
import Post from 'app/utils/Post';

export class CupController extends BaseController {
    private pendingUserTokenRefresh: Promise<CupUserTokenPayload> | null = null;

    constructor(private readonly store: CupStore) {
        super();
    }

    refreshUserToken(): Promise<CupUserTokenPayload> {
        if (this.pendingUserTokenRefresh) {
            return this.pendingUserTokenRefresh;
        }

        this.store.setUserTokenRefreshing(true);

        this.pendingUserTokenRefresh = new Post({url: '/cup/user_token'})
            .execute()
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.status);
                }

                return response.json();
            })
            .then((payload: CupUserTokenPayload) => {
                this.store.updateUserTokenPayload(payload);

                return payload;
            })
            .finally(() => {
                this.pendingUserTokenRefresh = null;
                this.store.setUserTokenRefreshing(false);
            });

        return this.pendingUserTokenRefresh;
    }
}
